<template>
  <div>
    <form class="border border-light p-0" v-on:submit.prevent="login">

        <input v-model="invoiceNumber"
               name="invoicenumber"
               type="text"
               class="form-control mb-2"
               placeholder="Rechnungs- oder Lieferschein Nr."
               autocomplete="off" required
        >

        <input v-model="postalCode" name="zipcode" type="password"  class="form-control mb-4" placeholder="Ihre Postleitzahl" autocomplete="off" required>

        <button class="btn btn-info btn-block mb-3" type="submit">Zu meinen Bestellungen</button>
    </form>
  </div>
</template>

<script>

    export default {
        name: "login-form",

        data() {
            return {
                invoiceNumber: '',
                postalCode: '',
                loginDialog: false
            }
        },

        methods: {
            login () {

                this.$swal({
                    text: 'Sie werden angemeldet..',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    buttons: false,
                })

                this.$RestClient.login( this.invoiceNumber, this.postalCode )
                    .then(data => {

                        if( data.login === 'failed' ){

                            this.$swal({
                                title: "Anmeldung fehlgeschlagen!",
                                text: "Bitte prüfen Sie ihre Daten und versuchen Sie es erneut!",
                                icon: "error",
                            });

                            return
                        }

                        if( data.login === 'guestuser' ){

                            this.$swal({
                                title: "Anmeldung nicht möglich!",
                                text: 'Da Sie als Gast bestellt haben, ist eine Anmeldung aufgrund der DSGVO nicht möglich! \n\n Bitte nutzen Sie den Button "Nachricht schreiben" !',
                                icon: "warning",
                            });

                            return
                        }

                        setTimeout(() => {
                            this.$store.commit('setLoginStatus', 'success')
                            this.$store.commit('setUserData', data)
                            this.$swal.close()
                        },1500)
                    })
            },
        },
    }
</script>

<style scoped>

</style>